import React, { useRef, useState } from "react";
import AddButton from "../buttons/button";
import ItemsInputField from "../forms/items-input-field";
import ItemsSelectField from "../forms/items-select-field";
import UploadIcon from "../../assets/icons/upload-icon";
import ViewIcon from "../../assets/icons/view-icon";
import { useFormikContext } from "formik";
import { ChevronUp, ChevronDown } from "lucide-react";
import { handleShowErrorToast } from "../helper-components/helper-function";
import { useNavigate } from "react-router-dom";

const ReturnBillFooterSection = ({
  docList = [],
  disabled,
  page = "create",
  returnCreateInputs = [],
}) => {
  const header_inv_dis_per_ref = useRef();
  const { values, setFieldValue, errors, validateForm } = useFormikContext();
  console.log(values, "dsfdsfsdfsdfsdfsdf");
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const onChangeHeaderDiscount = (
    header_inv_dis_per,
    icn_is_invoice_dis_percentage
  ) => {
    let updatedData = [...values?.data];

    // Update totals
    const icn_total_gst = updatedData.reduce(
      (total, item) => total + parseFloat(item.item_tax_amount || 0),
      0
    );
    const icn_total_discount = updatedData.reduce(
      (total, item) => total + parseFloat(item.item_discount_amount || 0),
      0
    );
    const icn_sub_total = updatedData.reduce(
      (subtotal, item) =>
        subtotal +
        parseFloat(item?.item_unit_price || 0) *
          parseFloat(item?.quantity || 0),
      0
    );

    const icn_total_without_inv_dis = updatedData.reduce(
      (total, item) => total + parseFloat(item.item_total_amount || 0),
      0
    );

    const icn_invoice_discount = icn_is_invoice_dis_percentage
      ? (icn_total_without_inv_dis * header_inv_dis_per) / 100
      : header_inv_dis_per;

    const icn_invoice_discount_percentage = icn_is_invoice_dis_percentage
      ? header_inv_dis_per
      : (header_inv_dis_per / icn_total_without_inv_dis) * 100;

    const icn_total_amount =
      updatedData.reduce(
        (total, item) => total + parseFloat(item.item_total_amount || 0),
        0
      ) - parseFloat(icn_invoice_discount);
    const rounded_total = Math.round(icn_total_amount);
    const roundoff = (rounded_total - icn_total_amount).toFixed(2);
    setFieldValue("icn_total_gst", icn_total_gst.toFixed(2));
    setFieldValue("icn_total_discount", icn_total_discount.toFixed(2));
    setFieldValue("icn_sub_total", icn_sub_total.toFixed(2));
    setFieldValue("icn_total_amount", rounded_total.toFixed(2));
    setFieldValue("icn_round_off_value", roundoff);
    setFieldValue("header_dis_per", "");
    setFieldValue("icn_invoice_discount", icn_invoice_discount?.toFixed(2));
    setFieldValue(
      "icn_invoice_discount_percentage",
      icn_invoice_discount_percentage
    );
  };

  return (
    <div className="h-[8rem]">
      <div className="h-[4rem] border-y border-[var(--create-table-footer-border)] flex items-center justify-between">
        <div className="flex w-[80%] h-full">
          {returnCreateInputs?.find((inp) => inp?.value === "remarks")
            ?.enabled && (
            <div className="w-[50%] px-5 border-r border-r-[var(--create-table-footer-border)] h-full flex items-center justify-center">
              <div className="w-[80%]">
                {" "}
                <ItemsInputField     
                  disabled={true}
                  name={`icn_remarks`}
                  isLabelReq={false}
                  placeholder="Enter your remarks here..."
                />
              </div>
            </div>
          )}

          {returnCreateInputs?.find(
            (inp) => inp?.value === "header_inv_dis_per"
          )?.enabled && (
            <div className="w-[50%] px-5 border-r border-r-[var(--create-table-footer-border)] h-full flex gap-3 items-center justify-center">
              {returnCreateInputs?.find(
                (inp) => inp?.value === "header_inv_dis_per"
              )?.enabled && (
                <div className={`w-[60%]  relative`}>
                  <ItemsInputField
                    ref={header_inv_dis_per_ref}
                    disabled={disabled || values?.data?.length === 0}
                    name={`header_inv_dis_per`}
                    isLabelReq={false}
                    placeholder={`Inv Disc ${
                      values?.icn_is_invoice_dis_percentage ? "%" : "₹"
                    }`}
                    onKeyDown={(event) => {
                      if (event.key === "Tab" || event.key === "Enter") {
                        onChangeHeaderDiscount(
                          parseFloat(event.target.value || 0),
                          values?.icn_is_invoice_dis_percentage
                        );
                      }
                    }}
                    onBlur={(event) => {
                      onChangeHeaderDiscount(
                        parseFloat(event.target.value || 0),
                        values?.icn_is_invoice_dis_percentage
                      );
                    }}
                  />
                  <button
                    disabled={disabled}
                    onClick={() => {
                      setFieldValue(
                        "icn_is_invoice_dis_percentage",
                        !values?.icn_is_invoice_dis_percentage
                      );
                      onChangeHeaderDiscount(
                        parseFloat(values?.header_inv_dis_per),
                        !values?.icn_is_invoice_dis_percentage
                      );
                    }}
                    type="button"
                    className="absolute top-1/2 -translate-y-1/2 right-0 w-[40px] min-h-[40px] flex items-center justify-center bg-[var(--create-tab-foot-subTot-bg)] border border-[var(--items-search-input-border)] rounded-r"
                  >
                    {values?.icn_is_invoice_dis_percentage ? "%" : "₹"}
                  </button>
                </div>
              )}
            </div>
          )}
        </div>

        <div
          className="justify-between w-[20%] px-5 h-full flex flex-col items-center
      bg-[var(--create-table-footer-totals-bg)] text-[var(--create-table-footer-totals-fg)]
      text-[length:var(--create-table-footer-totals-fs)] font-[var(--create-table-footer-totals-fw)] relative"
        >
          {/* Toggle Button */}
          {!isOpen && (
            <div
              className="absolute top-[-1.2rem] left-1/2 transform -translate-x-1/2 bg-[var(--create-table-footer-totals-bg)] cursor-pointer 
                    flex items-start justify-center"
              style={{
                width: "80px",
                height: "55px",
                borderRadius: "9999px", // makes it oval
                padding: "0.2rem",
              }}
              onClick={() => setIsOpen(!isOpen)}
            >
              {isOpen ? <ChevronDown size={18} /> : <ChevronUp size={18} />}
            </div>
          )}
          {isOpen && (
            <div
              className="p-5 flex flex-col w-full space-y-5 absolute bottom-[100%]"
              style={{
                backgroundColor: "var(--create-tab-foot-subTot-bg)",
                color: "var(--create-tab-foot-subTot-fg)",
                fontSize: "var(--create-tab-foot-subTot-fs)",
                fontWeight: "var(--create-tab-foot-subTot-fw)",
              }}
            >
              <div className="flex justify-between">
                <span>Sub Total</span>
                <span>₹{values?.icn_sub_total || "0.00"}</span>
              </div>
              <div className="flex justify-between">
                <span>Discount</span>
                <span style={{ color: "var(--success-color)" }}>
                  {"- "}₹{values?.icn_total_discount || "0.00"}
                </span>
              </div>
              <div className="flex justify-between">
                <span>Invoice Discount</span>
                <span style={{ color: "var(--success-color)" }}>
                  {"- "}₹{values?.icn_invoice_discount || "0.00"}
                </span>    
              </div>
              <div className="flex justify-between">
                <span>Round off</span>
                <span
                  className={
                    parseFloat(values?.icn_round_off_value || 0) > 0
                      ? "text-[var(--error-color)]"
                      : parseFloat(values?.icn_round_off_value || 0) < 0
                      ? "text-[var(--success-color)]"
                      : ""
                  }
                >
                  ₹{parseFloat(values?.icn_round_off_value || 0).toFixed(2)}
                </span>
              </div>
              <div className="flex justify-between">
                <span>Tax</span>
                <span style={{ color: "var(--error-color)" }}>
                  ₹{values?.icn_total_gst || "0.00"}
                </span>
              </div>
              <div
                className={`absolute top-[-2.3rem] left-1/2 transform -translate-x-1/2 bg-[var(--create-tab-foot-subTot-bg)] cursor-pointer 
              flex items-start justify-center `}
                style={{
                  width: "80px",
                  height: "55px",
                  borderRadius: "9999px", // makes it oval
                  padding: "0.2rem",
                }}
                onClick={() => setIsOpen(!isOpen)}
              >
                {isOpen ? <ChevronDown size={18} /> : <ChevronUp size={18} />}
              </div>
            </div>
          )}

          {/* Total Amount */}
          <div className="flex justify-between w-full h-full items-center">
            <span>Total</span>
            <span>₹{values?.icn_total_amount || "0.00"}</span>
          </div>
        </div>
      </div>

      <div className="h-[4rem] flex justify-between px-5">
        <div></div>
        <div className="flex gap-3 items-center">
          {!disabled && (
            <AddButton
              prefixIcon={false}
              text={"Draft"}
              className="
flex items-center px-[30px] h-[44px] whitespace-nowrap rounded-md gap-[8px]
bg-[var(--draft-button-bg)] cursor-pointer
text-[var(--draft-button-fg)]
border border-[var(--draft-button-border)]
text-[length:var(--draft-button-fs)] 
font-[var(--draft-button-fw)]
"
              type="submit"
              onclkFn={() => {
                setFieldValue("submittedButton", "draft");
                if (Object.keys(errors).length > 0) {
                  handleShowErrorToast(errors);
                }
              }}
            />
          )}
          <AddButton
            prefixIcon={false}
            text={disabled ? "View Payment Method" : "Proceed to Payment"}
            className="
flex items-center px-[30px] h-[44px] whitespace-nowrap rounded-md gap-[8px]
bg-[var(--primary-button-bg-color)] cursor-pointer
text-[var(--primary-button-fg-color)]
border border-[var(--primary-button-bg-color)]
hover:bg-[var(--primary-button-hover-color)]
text-[length:var(--primary-button-create-fs)] 
font-[var(--primary-button-font-weight)]
"
            type="submit"
            onclkFn={async () => {
              setFieldValue("submittedButton", "proceed");

              const formErrors = await validateForm();
              if (Object.keys(formErrors).length > 0) {
                handleShowErrorToast(formErrors);
              }
            }}
          />
          {disabled && values?.icn_order_status === "draft" && (
            <AddButton
              prefixIcon={false}
              text={"EDIT"}
              className="
flex items-center px-[30px] h-[44px] whitespace-nowrap rounded-md gap-[8px]
bg-[var(--primary-button-bg-color)] cursor-pointer
text-[var(--primary-button-fg-color)]
border border-[var(--primary-button-bg-color)]
hover:bg-[var(--primary-button-hover-color)]
text-[length:var(--primary-button-font-size)] 
font-[var(--primary-button-font-weight)]
"
              type="button"
              onclkFn={() => {
                navigate(`/edit-bill/${values?.icn_id}`);
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ReturnBillFooterSection;
